import axios from '../axios'

// 获取赛事的比赛时间与场地
export const address = data => {
  return axios({
    url: '/match/battle/address/' + data.matchId,
    method: 'get'
  })
}

// 获取赛事的比赛类型
export const matchType = data => {
  return axios({
    url: '/match/website/queryBigballPkType/' + data.matchId,
    method: 'get'
  })
}

// 查询大球类的赛程表
export const queryBigballPkDatas = data => {
  return axios({
    url: '/match/website/queryBigballPkDatas/' + data.matchId + '/' + data.isEnd + '/' + data.pageNum + '/' + data.pageSize + '/' + data.type,
    method: 'get'
  })
}

// 查询大球类的积分榜
export const footballIntegralRank = data => {
  return axios({
    url: '/match/football/footballIntegralRank/' + data.matchId,
    method: 'get'
  })
}

// 运动员技术表
export const playerGoal = data => {
  return axios({
    url: '/match/football/playerGoal/' + data.matchId,
    method: 'get'
  })
}

// 查询大球类的射手榜
export const footballGoalRank = data => {
  return axios({
    url: '/match/football/footballGoalRank/' + data.matchId,
    method: 'get'
  })
}

// 足球赛事球员红黄牌榜
export const footballPlayerCardRank = data => {
  return axios({
    url: '/match/football/footballPlayerCardRank/' + data.matchId,
    method: 'get'
  })
}

// 足球赛事球队红黄牌榜
export const footballTeamCardRank = data => {
  return axios({
    url: '/match/football/footballTeamCardRank/' + data.matchId,
    method: 'get'
  })
}

// 获取赛事的对战数据
export const list = data => {
  return axios({
    url: '/match/battle/list/' + data.matchId + '/' + data.addressName + '/' + data.matchTime + '/' + data.isEnd + '/' + data.pageNum + '/' + data.pageSize,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/comm/http/modules/battle.js